module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "dialog"
  }, [_c('div', {
    staticClass: "dialog-wrap"
  }, [_c('div', {
    staticClass: "dialog-header clearfix"
  }, [_c('img', {
    staticClass: "pull-right",
    attrs: {
      "src": "/static/img/dialog_close.png",
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isShow = false
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('span', {
    staticClass: "later",
    on: {
      "click": function($event) {
        _vm.isShow = false
      }
    }
  }, [_vm._v("稍后再说")]), _vm._v(" "), _c('span', {
    staticClass: "counsel",
    on: {
      "click": _vm.onclick
    }
  }, [_vm._v("现在咨询")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "doalog-text"
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("欢迎访问"), _c('span', {
    staticClass: "stress"
  }, [_vm._v("伟嘉安捷官方网站")]), _vm._v("！")]), _vm._v(" "), _c('p', [_vm._v("有什么可以帮助您的吗？")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-d0f0a428"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/combo/dialog.vue
// module id = 625
// module chunks = 1